import React from 'react';

const Remove = ({ height = 48, width = 48, color = '#E86C60', secondaryColor = '#FFFFFF' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>remove</title>
    <g>
      <path d="M45,1H3C1.89543,1,1,1.89543,1,3v42c0,1.10457,0.89543,2,2,2h42c1.10457,0,2-0.89543,2-2V3 C47,1.89543,46.10457,1,45,1z" fill={color}/>
      <path d="M34.29289,30.29289L28,24l6.29289-6.29289c0.39053-0.39053,0.39053-1.02369,0-1.41422l-2.58578-2.58579 c-0.39053-0.39052-1.02369-0.39052-1.41422,0L24,20l-6.29289-6.29289c-0.39053-0.39052-1.02369-0.39052-1.41422,0l-2.58579,2.58579 c-0.39052,0.39053-0.39052,1.02369,0,1.41422L20,24l-6.29289,6.29289c-0.39052,0.39053-0.39052,1.02369,0,1.41422l2.58579,2.58578 c0.39053,0.39053,1.02369,0.39053,1.41422,0L24,28l6.29289,6.29289c0.39053,0.39053,1.02369,0.39053,1.41422,0l2.58578-2.58578 C34.68342,31.31658,34.68342,30.68342,34.29289,30.29289z" fill={secondaryColor}/>
    </g>
  </svg>
);

export default Remove;
